<template>
  <v-app style="max-width:1200px; margin: 0 auto;">
    <v-app-bar
      app
      color="primary"
      dark
      v-if="$store.getters.env=='local' && $store.getters.debug"
    >
      <div class="d-flex align-center" @click="$router.push('/')">
        CUA
      </div>

      <v-spacer></v-spacer>

      <v-btn
        @click="$router.push('/questions')"
        text
      >
        <span class="mr-2">Questions</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

 

    <v-main>
      <v-dialog v-model="app.disclaimer.display" persistent>
        <v-card>
          <v-card-title>DISCLAIMER</v-card-title>
          <v-card-text>
            This application and the content herein are currently under development.
          </v-card-text>
          <v-card-text>
              <SiteBlocker/>
          </v-card-text>
          <!--
          <v-card-actions>
            <v-spacer/>
            <template v-if="$store.getters.env=='local'">
              <v-btn @click="app.disclaimer.display=false; $router.push('/')">CUA Kidney Cancer</v-btn>
            </template>
            <template v-else>
              <v-btn @click="app.disclaimer.display=false; $router.push('/surveys/kidney_cancer')">continue</v-btn>
            </template>
            <v-spacer/>
          </v-card-actions>
          -->
        </v-card>
      </v-dialog>
      
      <router-view v-if="!app.disclaimer.display"/>
    </v-main>
  </v-app>
</template>

<script>

import SiteBlocker from '@/components/siteBlocker/siteBlocker.vue'
import cache from '@/plugins/cache.js'

export default {
  name: 'App',
  components: {
    SiteBlocker  
  },
  created: function(){
    this.$store.commit('api',{
      local: process.env.VUE_APP_LOCAL_API,
      development: process.env.VUE_APP_DEV_API,
      staging: process.env.VUE_APP_STAGING_API,
      production: process.env.VUE_APP_API,
    })
    
    let siteBlocker = cache.storage.local.get('restricted')
    this.app.disclaimer.display = this.siteRestrictedState!=='yes' ?  false : (siteBlocker===null || siteBlocker==='yes') ? true : false
  },
  data: function(){
    return {
      app: {
        disclaimer: {
          display: true
          
        }
      }
    }
  },
  computed: {
    language: function(){
      return this.$store.getters.language
    },
    siteRestrictedState: function(){
        return this.$store.getters.restricted
    }
  },
  watch: {
    language: function(){
      this.$store.commit('language',this.language)
    },
    siteRestrictedState: function(after, before){
        console.log(before)
        this.app.disclaimer.display = after==='yes'
    }
  }
};
</script>

<style>
.debug{
  font-style: italic;
  color: red;
}
pre{
  white-space: pre-wrap;
}
body{
  background-color: #fafafa;
  overflow: hidden;
}
</style>